import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "structure-conditions-form" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "q-gutter-y-sm col-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "row q-mt-sm" }
const _hoisted_11 = { class: "col-4" }
const _hoisted_12 = { class: "row items-center" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "flex items-center" }

import { computed } from 'vue';

interface Props {
  // 検索種類
  searchType: string;
  // ez一致
  ez: boolean;
  // chiral一致
  chiral: boolean;
  // tautomer
  tautomer: boolean;
  // 閾値
  threshold: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StructureConditionsForm',
  props: {
    searchType: {},
    ez: { type: Boolean },
    chiral: { type: Boolean },
    tautomer: { type: Boolean },
    threshold: {}
  },
  emits: [
  'changeSearchType',
  'changeEz',
  'changeChiral',
  'changeTautomer',
  'changeThreshold',
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// 検索タイプ
const searchTypeComputed = computed({
  get: () => props.searchType,
  set: (value) => {
    emit('changeSearchType', value);
  },
});

// E/Z一致
const ezComputed = computed({
  get: () => props.ez,
  set: (value) => {
    emit('changeEz', value);
  },
});

// Chiral一致
const chiralComputed = computed({
  get: () => props.chiral,
  set: (value) => {
    emit('changeChiral', value);
  },
});

// Tautomer
const tautomerComputed = computed({
  get: () => props.tautomer,
  set: (value) => {
    emit('changeTautomer', value);
  },
});

// 閾値
const thresholdComputed = computed({
  get: () => props.threshold,
  set: (value) => {
    emit('changeThreshold', value);
  },
});

return (_ctx: any,_cache: any) => {
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_q_radio, {
            modelValue: searchTypeComputed.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTypeComputed).value = $event)),
            label: "完全一致",
            val: "perfect",
            color: "primary"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass([
            'row items-center q-mb-sm',
            searchTypeComputed.value !== 'perfect' && 'structure-conditions-form-disable',
          ])
        }, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-3 text-right q-mr-sm" }, "立体配置：", -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_q_checkbox, {
                modelValue: ezComputed.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ezComputed).value = $event)),
                disable: searchTypeComputed.value !== 'perfect',
                class: "q-mr-sm"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("E/Z一致")
                ])),
                _: 1
              }, 8, ["modelValue", "disable"]),
              _createVNode(_component_q_checkbox, {
                modelValue: chiralComputed.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((chiralComputed).value = $event)),
                disable: searchTypeComputed.value !== 'perfect'
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("Chiral一致")
                ])),
                _: 1
              }, 8, ["modelValue", "disable"])
            ])
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass([
            'row items-center ',
            searchTypeComputed.value !== 'perfect' && 'structure-conditions-form-disable',
          ])
        }, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col-3 text-right q-mr-sm" }, "Tautomer：", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_q_checkbox, {
              modelValue: tautomerComputed.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((tautomerComputed).value = $event)),
              disable: searchTypeComputed.value !== 'perfect'
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("含む")
              ])),
              _: 1
            }, 8, ["modelValue", "disable"])
          ])
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_q_radio, {
        modelValue: searchTypeComputed.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchTypeComputed).value = $event)),
        label: "部分一致",
        val: "partial",
        color: "primary"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_q_radio, {
          modelValue: searchTypeComputed.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((searchTypeComputed).value = $event)),
          label: "類似検索",
          val: "similar",
          color: "primary"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(['col', searchTypeComputed.value !== 'similar' && 'structure-conditions-form-disable'])
      }, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_q_input, {
                modelValue: thresholdComputed.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((thresholdComputed).value = $event)),
                outlined: "",
                dense: "",
                "reverse-fill-mask": "",
                mask: "###",
                disable: searchTypeComputed.value !== 'similar',
                "input-class": "text-right",
                class: "input-area",
                style: {"width":"98px"},
                maxlength: "3"
              }, null, 8, ["modelValue", "disable"]),
              _cache[12] || (_cache[12] = _createElementVNode("p", { class: "q-ml-sm q-mb-none" }, "%", -1))
            ])
          ])
        ])
      ], 2)
    ])
  ]))
}
}

})